import { deleteBannedVisitor, getBannedVisitors, getCustomerDomains, getVisitors } from "../../api/visitor";
import { log2 } from "../../utils/log2";
import * as _ from "lodash";
import { sendSocketMessage } from "../../utils/socketStream";

const log = log2("visitor.vuex");
const visitor = {
    namespaced: true,
    state: {
        bannedVisitors: {
            total: 0,
            count: 0,
            data: [],
        },
        visitors: {
            total: 0,
            count: 0,
            data: [],
        },
        liveVisitors: [], //bunlar site ziyaretcisi
        customerDomains: [],
        liveVisitorCount: 0,
    },
    mutations: {
        SET_LIVE_VISITOR_COUNT: (state, count) => {
            state.liveVisitorCount = count;
        },
        SET_VISITORS: (state, payload) => {
            log("SET_VISITORS", { payload });
            if (payload.infinityScroll === true) {
                state.visitors.data = state.visitors.data.concat(payload.data);
                state.visitors.data = state.visitors.data.filter((x) => !!x.visitor); //workaround: beta db değişince olmayan visitorId'ler peydahladı bunun için wa ekledim
            } else {
                state.visitors = payload;
            }
        },
        MULTI_VISITOR_UPDATE: (state, visitors) => {
            log("MULTI_VISITOR_UPDATE", { visitors });
            state.liveVisitors = _.uniqBy(visitors, (q) => q._id);
        },
        SET_MULTI_VISITOR_AS_PARTED: (state, { visitors, partNumber }) => {
            log("SET_MULTI_VISITOR_AS_PARTED", { visitors });
            if (partNumber === 1) {
                state.liveVisitors = visitors;
            } else {
                state.liveVisitors = _.concat(state.liveVisitors, visitors);
            }
        },
        UPDATE_VISITOR: (state, visitor) => {
            log("UPDATE_VISITOR", { visitor });
            const findIndex = _.findIndex(state.liveVisitors, (q) => q._id === visitor._id); //O(n) düzelt
            if (findIndex > 0) {
                state.liveVisitors[findIndex] = visitor;
            } else {
                state.liveVisitors = _.uniqBy([...state.liveVisitors, visitor], (q) => q._id); //O(n) düzelt
            }
        },
        BATCH_ADD_LIVE_VISITOR: (state, connectedIds) => {
            log("BATCH_ADD_LIVE_VISITOR", connectedIds);
            state.liveVisitors = _.uniq([...state.liveVisitors, ...connectedIds]);
        },
        SET_VISITOR_OFFLINE: (state, visitorId) => {
            log("SET_VISITOR_OFFLINE", { visitorId });
            state.liveVisitors = _.filter(state.liveVisitors, (q) => q._id !== visitorId);
        },
        MULTI_VISITOR_OFFLINE: (state, ids) => {
            log("MULTI_VISITOR_OFFLINE", {
                ids,
                before: state.liveVisitors.length,
                items: state.liveVisitors,
            });
            const idsMap = ids.reduce((acc, cur) => {
                acc[cur] = true;
                return acc;
            }, {});
            state.liveVisitors = state.liveVisitors.filter((id) => !idsMap[id]);
            log("MULTI_VISITOR_OFFLINE after", {
                ids,
                after: state.liveVisitors.length,
                items: state.liveVisitors,
                idsMap,
            });
        },
        SET_BANNED_VISITORS: (state, payload) => {
            log("SET_BANNED_VISITORS", { payload });
            state.bannedVisitors = payload;
        },
        DELETE_BANNED_VISITOR: (state, id) => {
            log("DELETE_BANNED_VISITOR", { id });
            state.bannedVisitors.data = state.bannedVisitors.data.filter((v) => v._id !== id); //O(n) düzelt
        },
        SET_CUSTOMER_DOMAINS: (state, data) => {
            state.customerDomains = data;
        },
        ADD_CUSTOMER_DOMAIN: (state, domain) => {
            state.customerDomains = _.uniq([...state.customerDomains, domain]);
        },
    },
    actions: {
        getVisitors({ commit, rootState }, payload) {
            return getVisitors(
                payload.perPage,
                payload.page,
                payload.startDate,
                payload.endDate,
                payload.query,
                payload.userId,
                payload.point,
                payload.description,
                payload.homeSite,
                payload.videoCall,
                payload.lostChats,
                rootState.subject.selectedSubject,
                payload.refs
            ).then((response) => {
                response.data.infinityScroll = payload.infinityScroll;
                commit("SET_VISITORS", response.data);
            });
        },
        getCustomerDomains({ commit }) {
            return getCustomerDomains().then((response) => {
                commit("SET_CUSTOMER_DOMAINS", response.data);
            });
        },
        getBannedvisitors({ commit }, payload) {
            const { page, perPage } = payload;
            return getBannedVisitors(perPage, page).then((response) => {
                commit("SET_BANNED_VISITORS", response.data);
            });
        },
        unbanVisitor({ commit }, id) {
            return deleteBannedVisitor(id).then((response) => {
                commit("DELETE_BANNED_VISITOR", id);
                return Promise.resolve(response);
            });
        },
        multiVisitorUpdate({ commit }, visitors) {
            commit("MULTI_VISITOR_UPDATE", visitors);
        },
        updateVisitor({ commit }, visitor) {
            commit("UPDATE_VISITOR", visitor);
        },
        batchAddLiveVisitor({ commit }, connectedIds) {
            commit("BATCH_ADD_LIVE_VISITOR", connectedIds);
        },
        setVisitorOffline({ commit }, visitorId) {
            commit("SET_VISITOR_OFFLINE", visitorId);
        },
        setMultiVisitorOffline({ commit }, ids) {
            commit("MULTI_VISITOR_OFFLINE", ids);
        },
        reportLiveVisitorCount({ rootState, commit, getters, state }, liveVisitorCount) {
            if (rootState.auth.user && rootState.site.site && rootState.socketStatus.socket_connected) {
                sendSocketMessage("user get-live-visitor-count", {
                    userId: rootState.auth.user._id,
                    liveVisitorCount,
                    siteId: rootState.site.site._id,
                });
            }
        },
        addCustomerDomain({ commit }, domain) {
            commit("ADD_CUSTOMER_DOMAIN", domain);
        },
        setMultiVisitorAsParted({ commit }, payload) {
            commit("SET_MULTI_VISITOR_AS_PARTED", payload);
        },
        setLiveVisitorCount({ commit }, count) {
            commit("SET_LIVE_VISITOR_COUNT", count);
        },
    },
};

export default visitor;
